import Login from '../views/LoginPage.vue';
import Reserve from '../views/ReservePage.vue';
import Setting from '../views/SettingPage.vue';
import Revenue from '../views/RevenuePage.vue';
import Users from '../views/UsersPage.vue';
import Space from '../views/SpacePage.vue';
import Schedule from '../views/SchedulePage.vue';
import PasswordForget from '../views/ForgetPassword.vue';
import Activity from '../views/ActivityPage.vue';
import Statistics from '../views/StatisticsPage.vue';
import DetailUserViewer from '../views/DetailUserViewer.vue';
import settingChildren from './setting';
import revenueChildren from './revenue';

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/reserve',
    name: 'Reserve',
    component: Reserve,
    needAuth: true,
  },
  {
    path: '/activity',
    name: 'Activity',
    // 頁面權限：選單與路由守衛共用（見 ./access.js）
    roles: ['admin', 'advstaff', 'accounting'],
    component: Activity,
    needAuth: true,
  },
  {
    path: '/statistics',
    name: 'Statistics',
    // 頁面權限：選單與路由守衛共用（見 ./access.js）
    roles: ['admin', 'advstaff', 'dispatcher', 'accounting'],
    component: Statistics,
    needAuth: true,
  },
  {
    path: '/setting',
    name: 'Setting',
    // 頁面權限：選單與路由守衛共用（見 ./access.js）；子頁另可設 adminOnly
    roles: ['admin', 'advstaff'],
    component: Setting,
    needAuth: true,
    children: settingChildren,
  },
  {
    path: '/revenue',
    name: 'Revenue',
    // 頁面權限：選單與路由守衛共用（見 ./access.js）
    roles: ['admin', 'accounting'],
    component: Revenue,
    needAuth: true,
    children: revenueChildren,
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    needAuth: true,
  },
  {
    path: '/user/:id',
    name: 'UserDetail',
    component: DetailUserViewer,
    needAuth: true,
    props: true,
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule,
    needAuth: true,
  },
  {
    path: '/space',
    name: 'Space',
    component: Space,
    needAuth: true,
  },
  {
    path: '/forget-password',
    name: 'PasswordForget',
    component: PasswordForget,
  },
  {
    path: '*',
    redirect: '/reserve',
  },
];
